var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconWarning(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 68,
    viewBox: "0 0 60 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5049_764)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_5049_764)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 30.0298,
    cy: 32.4158,
    r: 29.392,
    fill: "#FF0000"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 30.0298,
    cy: 32.4158,
    r: 27.8286,
    stroke: "black",
    strokeWidth: 3.1268
  })), /*#__PURE__*/React.createElement("mask", {
    id: "path-3-inside-1_5049_764",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.6331 38.304L22.3128 16.0289L36.2347 16.0289L33.9144 38.304L24.6331 38.304ZM29.2737 52.6384C27.28 52.6384 25.6471 52.0369 24.3753 50.8337C23.1034 49.5962 22.4674 48.1353 22.4674 46.4509C22.4674 44.7322 23.1034 43.2884 24.3753 42.1196C25.6471 40.9509 27.28 40.3665 29.2737 40.3665C31.3018 40.3665 32.9347 40.9509 34.1722 42.1196C35.444 43.2884 36.08 44.7322 36.08 46.4509C36.08 48.1353 35.444 49.5962 34.1722 50.8337C32.9347 52.0369 31.3018 52.6384 29.2737 52.6384Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M24.6331 38.304L22.3128 16.0289L36.2347 16.0289L33.9144 38.304L24.6331 38.304ZM29.2737 52.6384C27.28 52.6384 25.6471 52.0369 24.3753 50.8337C23.1034 49.5962 22.4674 48.1353 22.4674 46.4509C22.4674 44.7322 23.1034 43.2884 24.3753 42.1196C25.6471 40.9509 27.28 40.3665 29.2737 40.3665C31.3018 40.3665 32.9347 40.9509 34.1722 42.1196C35.444 43.2884 36.08 44.7322 36.08 46.4509C36.08 48.1353 35.444 49.5962 34.1722 50.8337C32.9347 52.0369 31.3018 52.6384 29.2737 52.6384Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.6331 38.304L22.3728 38.5395L22.585 40.5765L24.6331 40.5765L24.6331 38.304ZM22.3128 16.0289L22.3128 13.7564L19.7912 13.7564L20.0525 16.2644L22.3128 16.0289ZM36.2347 16.0289L38.495 16.2644L38.7562 13.7564L36.2347 13.7564L36.2347 16.0289ZM33.9144 38.304L33.9144 40.5765L35.9625 40.5765L36.1747 38.5395L33.9144 38.304ZM24.3753 50.8337L22.7905 52.4625L22.802 52.4737L22.8136 52.4847L24.3753 50.8337ZM24.3753 42.1196L25.9129 43.793H25.9129L24.3753 42.1196ZM34.1722 42.1196L32.6118 43.7718L32.6231 43.7825L32.6345 43.793L34.1722 42.1196ZM34.1722 50.8337L35.7563 52.4631L35.7569 52.4625L34.1722 50.8337ZM24.6331 38.304L26.8934 38.0686L24.5731 15.7935L22.3128 16.0289L20.0525 16.2644L22.3728 38.5395L24.6331 38.304ZM22.3128 16.0289L22.3128 18.3015L36.2347 18.3015L36.2347 16.0289L36.2347 13.7564L22.3128 13.7564L22.3128 16.0289ZM36.2347 16.0289L33.9744 15.7935L31.6541 38.0686L33.9144 38.304L36.1747 38.5395L38.495 16.2644L36.2347 16.0289ZM33.9144 38.304L33.9144 36.0315L24.6331 36.0315L24.6331 38.304L24.6331 40.5765L33.9144 40.5765L33.9144 38.304ZM29.2737 52.6384L29.2737 50.3659C27.7739 50.3659 26.7277 49.9308 25.937 49.1828L24.3753 50.8337L22.8136 52.4847C24.5666 54.143 26.786 54.911 29.2737 54.911L29.2737 52.6384ZM24.3753 50.8337L25.96 49.205C25.1016 48.3697 24.74 47.486 24.74 46.4509L22.4674 46.4509L20.1949 46.4509C20.1949 48.7845 21.1052 50.8228 22.7905 52.4625L24.3753 50.8337ZM22.4674 46.4509L24.74 46.4509C24.74 45.3718 25.1067 44.5338 25.9129 43.793L24.3753 42.1196L22.8376 40.4463C21.1001 42.043 20.1949 44.0925 20.1949 46.4509L22.4674 46.4509ZM24.3753 42.1196L25.9129 43.793C26.701 43.0688 27.7555 42.6391 29.2737 42.6391L29.2737 40.3665L29.2737 38.094C26.8044 38.094 24.5932 38.833 22.8376 40.4463L24.3753 42.1196ZM29.2737 40.3665L29.2737 42.6391C30.8398 42.6391 31.8749 43.0758 32.6118 43.7718L34.1722 42.1196L35.7325 40.4675C33.9945 38.826 31.7639 38.094 29.2737 38.094L29.2737 40.3665ZM34.1722 42.1196L32.6345 43.793C33.4407 44.5338 33.8075 45.3718 33.8075 46.4509L36.08 46.4509L38.3525 46.4509C38.3525 44.0925 37.4474 42.043 35.7098 40.4463L34.1722 42.1196ZM36.08 46.4509L33.8075 46.4509C33.8075 47.486 33.4459 48.3697 32.5874 49.205L34.1722 50.8337L35.7569 52.4625C37.4422 50.8228 38.3525 48.7845 38.3525 46.4509L36.08 46.4509ZM34.1722 50.8337L32.588 49.2043C31.8482 49.9236 30.8213 50.3659 29.2737 50.3659L29.2737 52.6384L29.2737 54.911C31.7824 54.911 34.0211 54.1501 35.7563 52.4631L34.1722 50.8337Z",
    fill: "black",
    mask: "url(#path-3-inside-1_5049_764)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_5049_764",
    x: 0.637817,
    y: 3.0238,
    width: 58.7839,
    height: 61.9107,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.1268
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5049_764"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5049_764",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5049_764"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 58.7839,
    height: 67,
    fill: "white",
    transform: "translate(0.637817 0.122803)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWarning);
export default __webpack_public_path__ + "static/media/icon-warning.e1caee043dae478740dbd55a6f9a60b5.svg";
export { ForwardRef as ReactComponent };